(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('DailyAllowanceEditModalController', DailyAllowanceEditModalController);

        DailyAllowanceEditModalController.$inject = ['$uibModalInstance', 'TravelExpenseService', 'dailyAllowanceController', 'toastr', 'sellers', 'expos', 'currencies', 'item'];

    function DailyAllowanceEditModalController($uibModalInstance, TravelExpenseService, dailyAllowanceController, toastr, sellers, expos, currencies, item) {
        var vm = this;

        vm.item = {};
        angular.copy(item, vm.item);

        vm.sellerSelected = vm.item.seller_id;
        vm.expoSelected = vm.item.expo_id;
        vm.currencySelected = vm.item.currency;
        vm.amount = vm.item.amount;
        vm.days = vm.item.days;

        vm.sellers = [];
        angular.copy(sellers, vm.sellers);
        vm.sellers.splice(0,1);

        vm.expos = [];
        angular.copy(expos, vm.expos);
        vm.expos.splice(0,1);
        

        vm.currencies = currencies;
        
        vm.ok = ok;
        vm.cancel = cancel;

        activate();

        function activate() {
        }

        function ok () {
            let query = {};
            query['id'] = vm.item.id;
            query['seller_id'] = vm.sellerSelected;
            query['expo_id'] = vm.expoSelected;
            query['currency'] = vm.currencySelected;
            query['amount'] = vm.amount;
            query['days'] = vm.days;
            TravelExpenseService.updateDailyAllowance(query).then(function(response, status) {
                if(response.status !== 200) {
                    toastr.error("An error ocurred on update this daily allowance");
                } else {
                    toastr.success("Daily allowance successfully updated!");
                    dailyAllowanceController.getByFilter();
                }
                $uibModalInstance.close();
            }).catch(function(err) {
                toastr.error('Error:'+err);
            });
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();